import { stepVariantTypes } from "./sequenceBlockers";

const LINKEDIN_TYPES = ["linkedinAuto", "linkedin"];

// True when any step/stage of the sequence has a LinkedIn touch point
// (automatic or manual). Reuses the same variant-type extraction sequenceBlockers
// uses, so this can never disagree with the blocker rules about what counts as LinkedIn.
export const hasLinkedInSteps = (sequence = {}) => {
  const types = stepVariantTypes(sequence?.steps || sequence?.stages || {});
  return LINKEDIN_TYPES.some(type => types.has(type));
};
